import { Navigate, useParams } from 'react-router-dom';
import type { ProjectKind } from '@aiai/shared';
import { useWorkspacePath } from '../../hooks/useWorkspacePath';
import { threadsHref } from '../../lib/projectNav';

/**
 * The pre-threads `…/chat/:sessionId?` URLs (bookmarks, old notifications)
 * land on the project's threads. A session id maps 1:1 onto a thread id (the
 * table was renamed, not re-keyed), so a deep link keeps pointing at the same
 * discussion.
 */
export function LegacyChatRedirect({ kind }: { kind: ProjectKind }) {
  const { projectId = '', sessionId } = useParams();
  const { wp } = useWorkspacePath();
  const base = threadsHref(kind, projectId);
  const to = sessionId && sessionId !== 'new' ? `${base}/${sessionId}` : sessionId === 'new' ? `${base}/new` : base;
  return <Navigate to={wp(to)} replace />;
}
